import map from 'lodash/map'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class DescriptionList extends Component {
  static propTypes = {
    className: PropTypes.string,
    listItems: PropTypes.object
  }

  static defaultProps = {
    listItems: {}
  }

  renderItem(value, key) {
    if (Array.isArray(value)) {
      value = value.join(', ')
    }

    return (
      <div key={key}>
        <span data-qv-description-list="key">{I18n.t(key) + ':'}</span>
        <span>{value}</span>
      </div>
    )
  }

  render() {
    const { listItems, className, ...rest } = this.props

    return (
      <div className="description-list" {...rest}>
        {map(listItems, this.renderItem)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/DescriptionList.js